<template>
  <div>
    <v-toolbar
      v-if="officeStaffFilterSet.office || getModel"
      flat
      color="white"
      class="mx-0 px-0"
    >
      <v-spacer />
      <v-btn
        color="success"
        rounded
        title="Добавить соискатель в команду"
        @click="enableBlackListForm"
      >
        <v-icon>fa-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <WBDPageOfficeStaffListFilter
        :office-staff-filter-set="officeStaffFilterSet"
        :hide-office="hideOffice"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!showAddBtn && getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="requestList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.options="{ item }">
        <v-btn
          icon
          small
          color="error"
          title="Удалить из команду"
          @click="removeMember(item, reload)"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <OfficeStaffCreateModal
      v-if="officeStaffFormEnabled"
      :filter-set="officeStaffCreateModalData"
      :display-self="officeStaffFormEnabled"
      :save-callback="reload"
      @onUserInOfficeStaff="onUserInOfficeStaff"
      @onCloseOfficeStaffFormModal="onUserInOfficeStaff"
    />
  </div>
</template>
<script>

import WBDPageOfficeStaffListFilter from '@/components/common/filter/page-office-staff-list-filter'
import ListMixin from '@/mixins/list-mixin'
import OfficeStaffMixin from '@/mixins/office-staff-mixin'
import OfficeStaffCreateModal from '@/components/common/office-staff/create'
import { pluriaizeRows } from '@/utils/plural-util'

export default {
  name: 'WBDOfficeStaffManager',
  components: {
    WBDPageOfficeStaffListFilter,
    OfficeStaffCreateModal,
  },
  mixins: [ListMixin, OfficeStaffMixin],
  props: {
    showAddBtn: {
      type: Boolean
    },
    office: {
      type: Object
    },
    user: {
      type: Object
    },

  },
  data: () => ({
    officeStaffCreateModalData: null,
    officeStaffFormEnabled: false,
    hideOffice: false,
    hideLevel: false,
    hideOrganization: false,
    hideUser: false,
    options: {},
    headers: [
      {
        text: 'создан',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Пользователь',
        align: 'left',
        sortable: false,
        value: 'laborer.fullName',
      },
      {
        text: 'Объект',
        align: 'left',
        sortable: false,
        value: 'office.title',
      },
      { text: '', value: 'options' },
    ],
  }),
  computed: {
    searchResultLabel () {
      return `Найдено: ${this.paginatorTotal} ${pluriaizeRows(this.paginatorTotal)}`
    },
    getModel () {
      const { office } = this.officeStaffFilterSet
      let model
      if (office) {
        model = office
      }

      return model
    },
    getActiveFilterNumber () {
      const params = {
        ...this.officeStaffFilterSet
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
  },
  watch: {
    options: {
      handler () {
        this.requestList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async  created () {
    if (this.office) {
      this.officeStaffFilterSet.office = this.office
      this.hideOffice = true
    }
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
  },
  methods: {
    onUserInOfficeStaff () {
      this.officeStaffFormEnabled = false
    },
    reload () {
      this.requestList(1, this.options.itemsPerPage)
    },
    enableBlackListForm () {
      const { office, user } = this.officeStaffFilterSet
      this.officeStaffCreateModalData =
          {
            user,
            'model': {
              'id': null,
            },
          }
      if (office) {
      }

      this.officeStaffCreateModalData.model = this.getModel
      if (user || this.officeStaffCreateModalData.model.id) {
        this.officeStaffFormEnabled = true
      }
    },
    async resetFilterSet () {
      this.officeStaffFilterSet = {
        office: null,
        user: null,
      }

      this.eventsBus.$emit(this.eventNames.PAGE_OFFICE_STAFF_LIST_FILTER_RESET)
    },
  }
}
</script>

